module.exports = __webpack_public_path__ + "media/images/caret-left-b758578b5fdb51779335c09aea65e892.svg";